import React, { useState } from 'react';
import { ReactComponent as DotsIcon } from '../../assets/svg/DotsIcon.svg';
import { FaEdit, FaKey, FaTrash, FaUser } from 'react-icons/fa';

const VerticalOptionsButton = ({ openUserProfileModal = (item: any) => {}, editProfile = (item: any) => {}, changePassword = (item: any) => {}, deleteProfile = (item: any) => {}, user = {} }) => {
	const [optionsVisible, setOptionsVisible] = useState(false);

	const viewProfile = () => {
		setOptionsVisible(false);
		openUserProfileModal(user);
	};

	const click = (e: any) => {
		e.stopPropagation();
	};
	return (
		<div className='flex justify-center items-center cursor-pointer relative ' onMouseEnter={() => setOptionsVisible(true)} onMouseLeave={() => setOptionsVisible(false)} onClick={click}>
			<div className='hover:bg-gray300 p-1  rounded-[4px]'>
				<DotsIcon />
			</div>
			{optionsVisible && (
				<div className='absolute w-[180px] p-[4px] rounded-[8px] -top-[20px] right-[30px]  bg-white border border-gray300 flex flex-col cursor-default z-[2] shadow-lg'>
					<div className='text-[14px] leading-5 font-medium text-gray600 cursor-pointer flex flex-row items-center gap-2 px-2 py-2 hover:text-gray900 hover:bg-gray50 rounded-[6px] transition' onClick={viewProfile}>
						<FaUser />
						View profile
					</div>
					<div className='text-[14px] leading-5 font-medium text-gray600 cursor-pointer flex flex-row items-center gap-2 px-2 py-2 hover:text-gray900 hover:bg-gray50 rounded-[6px] transition' onClick={() => editProfile(user)}>
						<FaEdit />
						Edit details
					</div>
					<div className='text-[14px] leading-5 font-medium text-gray600 cursor-pointer flex flex-row items-center gap-2 px-2 py-2 hover:text-gray900 hover:bg-gray50 rounded-[6px] transition' onClick={() => changePassword(user)}>
						<FaKey />
						Change password
					</div>
					<div className='text-[14px] leading-5 font-medium text-gray600 cursor-pointer flex flex-row items-center gap-2 px-2 py-2 hover:text-gray900 hover:bg-gray50 rounded-[6px] transition' onClick={() => deleteProfile(user)}>
						<FaTrash />
						Delete user
					</div>
				</div>
			)}
		</div>
	);
};

export default VerticalOptionsButton;
